// @flow

import { connect } from 'react-redux'
// $FlowFixMe
import { formValueSelector } from 'redux-form'
import { ADMIN_FEE } from 'src/helpers/constants'
import type { State as Store } from 'src/types/redux'
import { AdminForm } from './AdminForm'

const selector = formValueSelector('adminForm')

const mapStateToProps = (state: Store) => {
  const {
    encryption: { hasEncrypted, isProcessing, longUrl, shortUrl },
    locations: { availableLocations },
    auth: { authenticated, authError }
  } = state
  const roomType = selector(state, 'roomType')
  const bookingType = selector(state, 'bookingType')
  const corporateContact = selector(state, 'corporate_contact')
  const username = selector(state, 'username')
  const password = selector(state, 'password')
  const location = selector(state, 'location')
  const bookingDepositEdited = selector(state, 'bookingDepositEdited')
  const roomPriceEdited = selector(state, 'roomPriceEdited')

  return {
    hasEncrypted,
    username,
    password,
    isProcessing,
    longUrl,
    authenticated,
    authError,
    shortUrl,
    availableLocations,
    rooms: [],
    roomType,
    location,
    bookingType,
    corporateContact,
    bookingDepositEdited,
    roomPriceEdited,
    initialValues: {
      currency: {
        label: 'GBP - £',
        value: 'GBP'
      },
      roomType: {
        label: '',
        value: ''
      },
      yourName: {
        label: '',
        value: ''
      },
      preferredFloor: {
        label: '',
        value: ''
      },
      occupancyType: 'single',
      digitalVerification: '',
      hasRestrictedDuration: 'unrestricted',
      bookingDeposit: '',
      adminFee: ADMIN_FEE
    }
  }
}

const AdminFormContainer = connect(mapStateToProps, null)(AdminForm)

export default AdminFormContainer



// WEBPACK FOOTER //
// ./src/containers/Admin/index.js